import { render, staticRenderFns } from "./SalonDateSchedule.vue?vue&type=template&id=30879f4e&scoped=true&"
import script from "./SalonDateSchedule.vue?vue&type=script&lang=js&"
export * from "./SalonDateSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SalonDateSchedule.vue?vue&type=style&index=0&id=30879f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30879f4e",
  null
  
)

export default component.exports